import { useState, useEffect } from "react";
import Select from "../Select/Select";
import {
  Container,
  AppointmentInfo,
  StatusDiv,
  DetailInfo,
  VehiclesInfo,
  VehicleCard,
  VehicleRow,
  MainButton,
  Input,
  Row,
  WithdrawalByHandContainer,
  GrayBox,
} from "./VctTicketEditionSidebarStyles";
import Sidebar from "../Sidebar/Sidebar";
import RequestedInput from "../RequestedInput/RequestedInput";

import loadingGreen from "../../images/loading_gray.gif";
import plusIcon from "../../images/icon_plus.svg";
import deleteIcon from "../../images/icon_delete.svg";
import {
  saveAppointment,
  driverVerification,
} from "./VctTicketEditionSidebarAPI";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import { Checkbox } from "primereact/checkbox";
import { identifySegment } from "../VctAppointmentRequest/VctAppointmentRequest";
import { getErrorValueResponse } from "../../common/error/Error";
import { differenceInMinutes } from "date-fns";
import { DOCUMENT_DNI_MAX_LENGTH } from "../../utils/valueStaticConstants";
import { AppointmentConvert } from "../VctScreen/TurnTracking.interface";

const MAX_PLATE_VEHICLES = 10;

function populateOptions(options) {
  return options.map((option, index) => {
    return (
      <option key={index} value={option.value}>
        {option.label}
      </option>
    );
  });
}
const diffInMinutesFunction = (date: any) => {
  const timeDate = new Date();
  const mystartDate = new Date(date);
  const diffInMinutes = differenceInMinutes(timeDate, mystartDate);
  return diffInMinutes;
};

function populateOptionsTimesLot(options) {
  return options.map((option, index) => {
    return (
      <option key={index} value={option.value}>
        {option.label}
      </option>
    );
  });
}

function getNewVehicle(checked?: any) {
  return {
    checked,
    plate: "",
    category_option: "car",
    driverName: "",
    driverLicense: "",
    driverDocumentNumber: "",
    hasError: false,
    driverHasError: false,
  };
}

function populateRequest(appointment, showAddVehicle, timeslots) {
  const hasCheck = appointment.withdrawalByHand || appointment.withoutTransport;
  const withdrawalByHand = appointment.withdrawalType === "without_transport";
  const withoutTransport = appointment.withdrawalType === "pending_selection";
  const vehicleArray = withdrawalByHand || withoutTransport;
  const vehicles =
    appointment.vehicles.length > 0
      ? appointment.vehicles.map((v) => ({
          checked: !hasCheck,
          plate: v.plate,
          category_option: v.vehicle_category.option,
          driverName: v.driver.name,
          driverLicense: v.driver.brevete,
          driverDocumentNumber: v.driver.document_number,
          hasError: false,
          driverHasError: false,
        }))
      : !showAddVehicle && vehicleArray
      ? [getNewVehicle(hasCheck)]
      : [];
  const diferentMinutes = diffInMinutesFunction(appointment.timeslot.start);
  let respTimesLotId = "";

  if (timeslots.length > 0) {
    respTimesLotId =
      diferentMinutes >= -59
        ? timeslots[0]?.timeslotId
        : appointment.timeslot.timeslot_id;
  } else {
    respTimesLotId = appointment.timeslot.timeslot_id;
  }

  return {
    appointmentId: appointment.id,
    customsDispatcherId: appointment.dispatcherId,
    timeslotId: respTimesLotId,
    vehicles,

    withdrawalByHand,
    withoutTransport,
  };
}
interface Props {
  appointment: AppointmentConvert;
  onOutsideClick: () => void;
  loadInvoices: any;
  timeslots: any;
  dispatchers: any;
  vehicleCategories: any;
}

function VctTicketEditionSidebar(props: Props) {
  const {
    appointment,
    onOutsideClick,
    loadInvoices,
    timeslots,
    dispatchers,
    vehicleCategories,
  } = props;
  const [waitingServerResponse, updateWaitingServerResponse] =
    useState<boolean>(false);
  const [isEditDisabled, updateIsEditDisabled] = useState<boolean>(false);
  const [showVehicleModalWarning, setShowVehicleModalWarning] =
    useState<boolean>(false);
  const [vehicleMessageWarning, updateVehicleMessageWarning] =
    useState<string>("");
  const [showDniModalWarning, setShowDniModalWarning] =
    useState<boolean>(false);
  const [dniMessageWarning, updateDniMessageWarning] = useState("");

  const [showAddVehicle, setShowAddVehicle] = useState(false);
  const [request, updateRequest] = useState(
    populateRequest(appointment, showAddVehicle, timeslots)
  );
  const [showConfirmationModal, updateShowConfirmationModal] = useState(false);
  const [withdrawalType, setWithdrawalType] = useState(
    appointment.withdrawalType
  );
  const isHandPickupDisabled = Number(appointment.parcelsWeight) > 30;
  function updateRequestField(modifierFn) {
    let newRequest = { ...request };
    modifierFn(newRequest);
    updateRequest(newRequest);
  }

  const [licensePlate, updateLicensePlate] = useState(false);

  const isChangeSelect = (requestDataVehicles) => {
    const dataVehicles = requestDataVehicles.vehicles.filter(
      (vehicleC) =>
        vehicleC.plate.length > 0 &&
        vehicleC.driverName.length > 0 &&
        vehicleC.driverLicense.length > 0 &&
        vehicleC.checked === true
    );
    const vehiclesData = requestDataVehicles.vehicles.map(
      (vehicle) => vehicle.driverDocumentNumber
    );

    const filterVehicleRepeat = vehiclesData.filter((item, index) => {
      return vehiclesData.indexOf(item) === index;
    });

    if (requestDataVehicles.vehicles.length === dataVehicles.length) {
      if (filterVehicleRepeat.length === requestDataVehicles.vehicles.length) {
        updateLicensePlate(true);
        setShowMessageErrorAppointment("");
      } else if (filterVehicleRepeat.length !== vehiclesData.length) {
        setShowMessageErrorAppointment(
          "DNI dublicado, ingrese datos correctos"
        );
        updateIsEditDisabled(true);
      } else {
        updateLicensePlate(false);
        setShowMessageErrorAppointment("");
      }
    } else if (vehiclesData.length === filterVehicleRepeat.length) {
      updateLicensePlate(false);
      setShowMessageErrorAppointment("");
    } else {
      setShowMessageErrorAppointment("DNI duplicado, ingrese datos correctos");
      updateIsEditDisabled(true);
    }
  };

  const [showMessageErrorAppointment, setShowMessageErrorAppointment] =
    useState("");
  function addVehicle() {
    if (request.withoutTransport) {
      updateVehicleMessageWarning(
        "Le informamos que no es posible registrar transportistas con la opción <<Citas sin datos del transporte>> marcada."
      );
      setShowVehicleModalWarning(true);
      return;
    }
    if (request.vehicles.length >= vehicleCategories.maxVehicles) {
      updateVehicleMessageWarning(
        `Le informamos que solo es posible registrar como máximo ${vehicleCategories.maxVehicles} transportistas por cada cita.`
      );
      setShowVehicleModalWarning(true);
      return;
    }
    let newRequest = {
      ...request,
      vehicles: [...request.vehicles, getNewVehicle()],
    };
    updateRequest(newRequest);
    isChangeSelect(newRequest);
  }
  const [showMessageError, setShowMessageError] = useState("");

  function deleteVehicle(idx) {
    let newRequest = { ...request };
    newRequest.vehicles.splice(idx, 1);
    updateRequest(newRequest);
    isChangeSelect(newRequest);
  }

  const saveChanges = () => {
    const withdrawal_type = withdrawalType;
    const newRequest = { ...request };
    if (request.withdrawalByHand || request.withoutTransport) {
      newRequest.vehicles = [];
    }
    let validRequest = true;
    newRequest.vehicles.forEach((vehicle, index) => {
      if (vehicle.plate.length === 0) {
        newRequest.vehicles[index].hasError = true;
        validRequest = false;
      }
      if (
        vehicle.driverDocumentNumber.length === 0 ||
        vehicle.driverLicense.length === 0 ||
        vehicle.driverName.length === 0
      ) {
        newRequest.vehicles[index].driverHasError = true;
        validRequest = true;
      }
    });
    updateRequest(newRequest);
    if (!validRequest || waitingServerResponse) return;
    updateIsEditDisabled(false);
    updateWaitingServerResponse(true);
    saveAppointment(newRequest, withdrawal_type)
      .then(() => {
        updateWaitingServerResponse(false);
        toggleConfirmationModal();
      })
      .catch((error) => {
        const errorMessage = getErrorValueResponse(error);
        setShowMessageError(errorMessage);
        updateIsEditDisabled(true);
        updateWaitingServerResponse(false);
      });
  };

  const toggleConfirmationModal = () => {
    updateShowConfirmationModal(!showConfirmationModal);
  };

  const onWithdrawalByHandCheck = (e) => {
    updateRequest({
      ...request,
      withdrawalByHand: !request.withdrawalByHand,
      withoutTransport: false,
    });
    if (e.target.checked) {
      setWithdrawalType("without_transport");
    } else {
      setWithdrawalType("with_transport");
    }
  };

  const onWithoutTransportCheck = (e) => {
    updateRequest({
      ...request,
      withoutTransport: !request.withoutTransport,
      withdrawalByHand: false,
    });
    if (e.target.checked) {
      setWithdrawalType("pending_selection");
    } else {
      setWithdrawalType("with_transport");
    }
  };

  const [dniValidate, updateDniValidate] = useState(
    appointment.vehicles.length > 0
  );
  const [nameDispatcherName, updateNameDispatcherName] = useState(true);
  const [timeWithDrawalDate, updateTimeWithDrawalDate] = useState(true);
  const [typeVehicle, updateTypeVehicle] = useState(true);

  const isButtonDisabledvehicle =
    !nameDispatcherName ||
    !timeWithDrawalDate ||
    !typeVehicle ||
    !licensePlate ||
    !dniValidate;

  const isButtonDisabledHand =
    !nameDispatcherName ||
    !timeWithDrawalDate ||
    (!request.withdrawalByHand && !request.withoutTransport);
  const isButtonDisabled = !isButtonDisabledvehicle || !isButtonDisabledHand;

  useEffect(() => {
    const addVehicleShow = request.withdrawalByHand || request.withoutTransport;
    setShowAddVehicle(addVehicleShow);
  }, [request, withdrawalType]);

  useEffect(() => {
    isChangeSelect(request);
    // eslint-disable-next-line
  }, [isChangeSelect]);

  const [DniBlankShow, setDniBlankShow] = useState(false);
  const dniBlankFilter = (request_payload) => {
    const driversDocumentNumber = request_payload.vehicles
      .map((document) => document.driverDocumentNumber)
      .filter((e: string) => e === "");
    const driversLicense = request_payload.vehicles
      .map((document) => document.driverLicense)
      .filter((e: string) => e === "");
    if (driversDocumentNumber.length > 0 || driversLicense.length > 0) {
      setDniBlankShow(true);
    } else {
      setDniBlankShow(false);
    }
  };

  useEffect(() => {
    dniBlankFilter(request);
  }, [request]);

  return showConfirmationModal ? (
    <ConfirmationModal
      title={"Cita editada con éxito"}
      message={"La información de su cita ha sido editada correctamente."}
      toggleModal={() => {
        onOutsideClick();
        toggleConfirmationModal();
        loadInvoices.retry();
      }}
      onAccept={() => {
        onOutsideClick();
        toggleConfirmationModal();
        loadInvoices.retry();
      }}
    />
  ) : (
    <>
      <Sidebar onOutsideClick={onOutsideClick}>
        <Container>
          <AppointmentInfo>
            <p className="appointment-id">{`ID: ${appointment.appointmentNum}`}</p>
            <p className="appointment-title">Editar Cita</p>
            <StatusDiv status={appointment.appointmentStatus.category}>
              <span>{appointment.appointmentStatus.label.toUpperCase()}</span>
            </StatusDiv>
          </AppointmentInfo>
          <DetailInfo>
            <Row>
              <h2>NOMBRE DEL DESPACHADOR</h2>
            </Row>
            <Row>
              <Select
                name="dispatcherName"
                onChange={(e) => {
                  updateRequestField((newRequest) => {
                    newRequest.customsDispatcherId = e.target.value;
                  });
                  isChangeSelect(request);
                  if (e.target.value.length > 3) {
                    updateNameDispatcherName(true);
                  } else {
                    updateNameDispatcherName(false);
                  }
                }}
                value={request.customsDispatcherId}
                width="fill-available"
                arrowPosition="2.2rem"
              >
                {populateOptions(dispatchers)}
              </Select>
            </Row>
            <Row>
              <h2>HORA DE RETIRO</h2>
            </Row>
            <Row>
              <Select
                name="timeslot"
                onChange={(e) => {
                  updateRequestField((request) => {
                    request.timeslotId = e.target.value;
                  });
                  isChangeSelect(request);
                  if (e.target.value.length > 3) {
                    updateTimeWithDrawalDate(true);
                  } else {
                    updateTimeWithDrawalDate(false);
                  }
                }}
                value={request.timeslotId}
                width="fill-available"
              >
                {populateOptionsTimesLot(timeslots)}
              </Select>
            </Row>

            <Row>
              <h2>SEGMENTO</h2>
            </Row>
            <Row>
              <Input
                type="text"
                className="segment"
                disabled
                value={identifySegment(
                  appointment.groupsNum,
                  request?.vehicles.length > 0 &&
                    request.vehicles.map((v) => v.category_option),
                  request.withdrawalByHand,
                  request.withoutTransport
                )}
              />
            </Row>
          </DetailInfo>
          <div className="request-options">
            <WithdrawalByHandContainer>
              <Checkbox
                onChange={onWithdrawalByHandCheck}
                onClick={(e) => e.stopPropagation()}
                disabled={isHandPickupDisabled}
                tooltip={
                  isHandPickupDisabled
                    ? "El peso de la carga es mayor a 30 kg."
                    : null
                }
                checked={request.withdrawalByHand}
              />
              <span>Retiro a mano</span>
            </WithdrawalByHandContainer>
            <WithdrawalByHandContainer>
              <Checkbox
                onChange={onWithoutTransportCheck}
                onClick={(e) => e.stopPropagation()}
                checked={request.withoutTransport}
              />
              <span>Citas sin datos del transporte</span>
            </WithdrawalByHandContainer>
          </div>
          <div style={{ maxHeight: "33rem" }}>
            <VehiclesInfo style={{ overflowY: "auto", maxHeight: "27rem" }}>
              {!request.withdrawalByHand && !request.withoutTransport && (
                <h1>{`Vehículos (${request.vehicles.length})`}</h1>
              )}
              {!request.withdrawalByHand &&
                !request.withoutTransport &&
                request.vehicles.map((vehicle, index) => {
                  return (
                    <div key={index} style={{ marginTop: "-5px" }}>
                      {request.vehicles.length > 1 ? (
                        <div
                          className="delete-vehicle"
                          onClick={() => deleteVehicle(index)}
                        >
                          <img src={deleteIcon} alt="Borrar" />
                          Eliminar
                        </div>
                      ) : null}

                      <VehicleCard>
                        <VehicleRow>
                          <div className="vehicle-type">
                            <h2>TIPO DE VEHÍCULO</h2>
                            <Select
                              name={"vehicleType" + index}
                              onChange={(e) => {
                                isChangeSelect(request);
                                updateRequestField((newRequest) => {
                                  newRequest.vehicles[index].category_option =
                                    e.target.value;
                                });
                                if (e.target.value.length > 1) {
                                  updateTypeVehicle(true);
                                } else {
                                  updateTypeVehicle(false);
                                }
                              }}
                              value={request.vehicles[index].category_option}
                              arrowPosition="2.2rem"
                              width="15rem"
                              height="4.5rem"
                            >
                              {populateOptions(vehicleCategories.labels)}
                            </Select>
                          </div>
                          <div>
                            <h2>PLACA</h2>
                            <Input
                              type="text"
                              className="licensePlate"
                              onChange={(e) => {
                                isChangeSelect(request);
                                updateRequestField((request) => {
                                  request.vehicles[index].hasError = false;
                                  request.vehicles[index].plate =
                                    e.target.value;
                                });
                              }}
                              value={request.vehicles[index].plate}
                              hasError={vehicle.hasError}
                              width="12rem"
                              height="4.5rem"
                              maxLength={MAX_PLATE_VEHICLES}
                            />
                          </div>
                        </VehicleRow>
                        <VehicleRow>
                          <div>
                            <h2>DNI</h2>
                            <RequestedInput
                              hasError={request.vehicles[index].driverHasError}
                              width="15rem"
                              value={vehicle.driverDocumentNumber}
                              onChangeValue={(ev) => {
                                isChangeSelect(request);
                                updateRequestField((request) => {
                                  request.vehicles[index].driverDocumentNumber =
                                    ev.target.value;
                                  request.vehicles[index].driverName = "";
                                  request.vehicles[index].driverLicense = "";
                                  request.vehicles[index].driverHasError =
                                    false;
                                });
                              }}
                              maxLength={DOCUMENT_DNI_MAX_LENGTH}
                              placeholder="DNI"
                              checked={vehicle.checked}
                              onChangeCheck={(ev) => {
                                const newDriverCheckedStatus =
                                  ev.target.checked;
                                vehicle.checked = newDriverCheckedStatus;
                                if (newDriverCheckedStatus) {
                                  isChangeSelect(request);
                                  driverVerification(
                                    request.vehicles[index].driverDocumentNumber
                                  )
                                    .then((response) => {
                                      updateRequestField((request) => {
                                        request.vehicles[index].driverName =
                                          response.name;
                                        request.vehicles[index].driverLicense =
                                          response.brevete;
                                      });
                                      updateDniValidate(true);
                                      isChangeSelect(request);
                                    })
                                    .catch((error) => {
                                      isChangeSelect(request);
                                      updateRequestField((request) => {
                                        request.vehicles[index].driverHasError =
                                          true;
                                        request.vehicles[index].checked = false;
                                      });
                                      updateDniValidate(false);
                                      const errorMessage =
                                        getErrorValueResponse(error);
                                      updateDniMessageWarning(errorMessage);
                                      setShowDniModalWarning(true);
                                    });
                                } else {
                                  isChangeSelect(request);
                                  setShowMessageErrorAppointment("");
                                  updateIsEditDisabled(false);
                                  updateRequestField((request) => {
                                    request.vehicles[index].driverName = "";
                                    request.vehicles[index].driverLicense = "";
                                  });
                                }
                              }}
                            />
                          </div>
                          <div>
                            <h2>BREVETE</h2>
                            <GrayBox width="12rem">
                              {vehicle.checked && (
                                <span>{vehicle.driverLicense}</span>
                              )}
                            </GrayBox>
                          </div>
                        </VehicleRow>
                        <VehicleRow>
                          <div>
                            <h2>TRANSPORTISTA</h2>
                            <GrayBox width="29rem">
                              {vehicle.checked && (
                                <span>{vehicle.driverName}</span>
                              )}
                            </GrayBox>
                          </div>
                        </VehicleRow>
                      </VehicleCard>
                    </div>
                  );
                })}

              {!DniBlankShow && (
                <>
                  {!request.withdrawalByHand && !request.withoutTransport && (
                    <Row onClick={addVehicle}>
                      <img src={plusIcon} alt="Agregar" />
                      <h2 className="add-vehicle">Añadir vehículo</h2>
                    </Row>
                  )}
                </>
              )}
            </VehiclesInfo>
          </div>
          <div className="submitButton">
            {isEditDisabled && showMessageErrorAppointment && (
              <div className="block-hint">{showMessageErrorAppointment}</div>
            )}
            {showMessageError && (
              <div className="block-hint">{showMessageError}</div>
            )}
            <MainButton
              onClick={saveChanges}
              disabled={!isButtonDisabled || waitingServerResponse}
            >
              {waitingServerResponse && (
                <img
                  src={loadingGreen}
                  width="50"
                  height="50"
                  alt="Processing request"
                />
              )}
              Guardar cita
            </MainButton>
          </div>
        </Container>
      </Sidebar>
      {showVehicleModalWarning && (
        <ConfirmationModal
          message={vehicleMessageWarning}
          onAccept={() => {
            setShowVehicleModalWarning(false);
          }}
          title="Alerta de añadir vehículo"
          toggleModal={() => {
            setShowVehicleModalWarning(false);
          }}
        />
      )}
      {showDniModalWarning && (
        <ConfirmationModal
          message={dniMessageWarning}
          onAccept={() => {
            setShowDniModalWarning(false);
          }}
          title="Validación de DNI"
          toggleModal={() => {
            setShowDniModalWarning(false);
          }}
        />
      )}
    </>
  );
}

export default VctTicketEditionSidebar;
